import Actions from "./Actions";
import SharedWith from "./SharedWith";

const inAppShareComponents = {
  Actions,
  SharedWith
}

export default inAppShareComponents